import React, { useState } from 'react';
import { XMarkIcon, DocumentTextIcon } from '@heroicons/react/24/outline';
import { useSip } from '../../SipContext';
import axios from '../../../configApi/axiosConfig';
import { APIURL } from '../../../configApi/apiConfig';

import { useDetalleCobranzaData } from './hooks/useDetalleCobranzaData';
import { DashboardHeader } from './components/DashboardHeader';
import { TabNavigation } from './components/TabNavigation';
import { TabContent } from './components/TabContent';

export function DetalleCobranza({ isOpen, onClose, data, estadoGestion, item, isPage = false }) {
    const { openDialer, phoneAvailable } = useSip();
    const [activeTab, setActiveTab] = useState('GESTION');
    const [selectedId, setSelectedId] = useState(null);

    const {
        loading,
        selectResultado,
        direccionData,
        datosCobranza,
        historialAPI,
        amortizacionStats,
        articulosFactura,
        refetch
    } = useDetalleCobranzaData(data, isOpen);

    const handleGuardarTelefonos = async (telefonosGuardados) => {
        try {
            const userInfoString = localStorage.getItem('userInfo');
            const userInfo = userInfoString ? JSON.parse(userInfoString) : null;
            const usuario = userInfo?.Usuario || 'SISTEMA';
            const estacion = userInfo?.Estacion || 'WEB';
            let idCliente = data?.idCliente || item?.idCliente || null;
            const cedula = data?.Cedula || item?.Cedula || null;

            if (!idCliente && cedula) {
                try {
                    const res = await axios.get(APIURL.getCliente(cedula));
                    if (res.data?.success && res.data?.data?.idCliente) {
                        idCliente = res.data.data.idCliente;
                    }
                } catch (error) {
                    console.error("Error fetching idCliente:", error);
                }
            }

            const promesas = telefonosGuardados.map(async (t) => {
                if (t.idCre_GCTelefono && t.idCre_GCTelefono.toString().startsWith('TELF_') && 
                    !t.idCre_GCTelefono.toString().startsWith('TELF_INIT_') && 
                    !t.idCre_GCTelefono.toString().startsWith('TELF_DB_') &&
                    !t.idCre_GCTelefono.toString().startsWith('TELF_MAESTRO_')) {
                    const payload = {
                        idCliente: idCliente,
                        Telefono: t.telefono,
                        Descripcion: t.descripcion,
                        FechaSistema: new Date(),
                        Estacion: estacion,
                        Usuario: usuario
                    };
                    return axios.post(APIURL.post_creGcTelefono(), payload);
                }
                return Promise.resolve();
            });

            await Promise.all(promesas);
            alert('Teléfonos guardados exitosamente');
            setActiveTab('GESTION');
        } catch (error) {
            console.error('Error guardando teléfonos:', error);
            alert('Error al guardar los teléfonos');
        }
    };

    if (!isOpen) return null;

    return (
        <div className={isPage ? "w-full h-full bg-slate-100" : "fixed inset-0 z-50 overflow-hidden"}>
            {/* Overlay */}
            {!isPage && <div className="absolute inset-0 bg-black/50 backdrop-blur-md transition-opacity" onClick={onClose}></div>}

            {/* Modal */}
            <div className={isPage ? "w-full mx-auto" : "absolute inset-0 overflow-hidden"}>
                <div className={isPage ? "flex items-start justify-center min-h-screen" : "flex items-center justify-center min-h-screen p-4"}>
                    <div className={`relative bg-white shadow-2xl w-full flex flex-col ${isPage ? 'min-h-screen' : 'rounded-3xl max-w-7xl max-h-[95vh] overflow-hidden'}`}>
                        
                        {/* Header Title Premium */}
                        <div className="relative bg-gradient-to-r from-slate-900 via-blue-800 to-slate-900 px-6 py-4 flex items-center justify-between overflow-hidden">
                            <div className="absolute inset-0 opacity-10">
                                <div className="absolute top-0 right-0 w-96 h-96 bg-blue-400 rounded-full mix-blend-multiply filter blur-3xl"></div>
                                <div className="absolute bottom-0 left-0 w-96 h-96 bg-blue-600 rounded-full mix-blend-multiply filter blur-3xl"></div>
                            </div>

                            <div className="relative flex-1 flex items-center gap-4">
                                <div className="p-2 bg-gradient-to-br from-blue-400 to-blue-600 rounded-2xl shadow-lg">
                                    <DocumentTextIcon className="w-6 h-6 text-white" />
                                </div>
                                <div className="text-white">
                                    <h2 className="text-xl font-bold tracking-tight">Historial de Gestiones</h2>
                                </div>
                            </div>
                            {!isPage && (
                                <button
                                    onClick={onClose}
                                    className="relative p-2.5 hover:bg-white/20 rounded-xl transition-all duration-200 hover:scale-110"
                                >
                                    <XMarkIcon className="w-6 h-6 text-white" />
                                </button>
                            )}
                        </div>

                        {/* Premium Dashboard Cards */}
                        <DashboardHeader 
                            data={data} 
                            item={item} 
                            direccionData={direccionData} 
                            amortizacionStats={amortizacionStats}
                            articulosFactura={articulosFactura}
                        />

                        {/* Tabs Navigation */}
                        <TabNavigation 
                            activeTab={activeTab} 
                            setActiveTab={setActiveTab} 
                            setSelectedId={setSelectedId} 
                            data={data} 
                        />

                        {/* Content - Scrollable */}
                        <div className="overflow-y-auto flex-1 min-h-0 bg-slate-50 relative">
                            <div className="p-4 md:px-6 md:py-4">
                                <TabContent 
                                    activeTab={activeTab} 
                                    setActiveTab={setActiveTab} 
                                    selectedId={selectedId}
                                    data={data} 
                                    estadoGestion={estadoGestion} 
                                    historialAPI={historialAPI} 
                                    direccionData={direccionData} 
                                    loading={loading}
                                    handleGuardarTelefonos={handleGuardarTelefonos} 
                                    refetch={refetch}
                                />
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
}
